import React, { useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { CrsEntryModel, HsnTsnModel } from "../../api/hsntsnApi";

interface CrsHsnTsnProps {
  entries: CrsEntryModel[];
  selectedEntries: HsnTsnModel[];
  disabled: boolean;
  selectionChanged: (hsn: string, tsn: string, selected: boolean) => void;
  crsEntriesModified: (entries: CrsEntryModel[]) => void;
}

function CrsHsnTsn({
  entries,
  selectedEntries,
  disabled,
  selectionChanged,
  crsEntriesModified,
}: CrsHsnTsnProps) {
  const [selectedCrsEntry, setSelectedCrsEntry] = useState<
    CrsEntryModel | undefined
  >();
  const [editCrsEntry, setEditCrsEntry] = useState<CrsEntryModel | undefined>();

  const crsEntryAdded = (entry: CrsEntryModel) => {
    crsEntriesModified(entries.concat(entry));

    selectionChanged(entry.hsn!, entry.tsn!, true);
  };

  const crsEntryModified = (
    originalEntry: CrsEntryModel,
    entry: CrsEntryModel,
  ) => {
    crsEntriesModified(entries.map((x) => (x === originalEntry ? entry : x)));
  };

  const isSelected = (entry: CrsEntryModel) => {
    return (
      (selectedEntries?.findIndex(
        (x) => x.hsn === entry.hsn && x.tsn === entry.tsn,
      ) ?? -1) >= 0
    );
  };

  return (
    <Table>
      <thead>
        <tr>
          <th>Include</th>
          <th>HSN</th>
          <th>TSN</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {(entries.length ?? 0) === 0 ? (
          <tr>
            <td colSpan={5}>No CRS entries...</td>
          </tr>
        ) : (
          entries.map((x) => (
            <tr
              key={`${isSelected(x)}_${x.hsn}_${x.tsn}`}
              role={!selectedCrsEntry ? "button" : ""}
              onClick={() => {
                if (!selectedCrsEntry && !disabled) {
                  setSelectedCrsEntry(x);
                  setEditCrsEntry({
                    hsn: x.hsn,
                    tsn: x.tsn,
                    description: x.description,
                  });
                }
              }}
            >
              <td>
                <Form.Check
                  defaultChecked={isSelected(x)}
                  onChange={(e) =>
                    selectionChanged(x.hsn!, x.tsn!, e.target.checked)
                  }
                  disabled={disabled}
                />
              </td>
              {selectedCrsEntry !== x && (
                <>
                  <td>{x.hsn}</td>
                  <td>{x.tsn}</td>
                  <td>{x.description}</td>
                  <td></td>
                </>
              )}

              {selectedCrsEntry === x && editCrsEntry && (
                <>
                  <td>
                    <Form.Control
                      defaultValue={editCrsEntry.hsn}
                      onChange={(e) =>
                        setEditCrsEntry({
                          ...editCrsEntry,
                          hsn: e.target.value,
                        })
                      }
                    />
                  </td>
                  <td>
                    <Form.Control
                      defaultValue={editCrsEntry.tsn}
                      onChange={(e) =>
                        setEditCrsEntry({
                          ...editCrsEntry,
                          tsn: e.target.value,
                        })
                      }
                    />
                  </td>
                  <td>
                    <Form.Control
                      defaultValue={editCrsEntry.description}
                      onChange={(e) =>
                        setEditCrsEntry({
                          ...editCrsEntry,
                          description: e.target.value,
                        })
                      }
                    />
                  </td>
                  <td>
                    <Button
                      onClick={(evt) => {
                        crsEntryModified(x, editCrsEntry);
                        setSelectedCrsEntry(undefined);
                        setEditCrsEntry(undefined);
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      onClick={() => {
                        setSelectedCrsEntry(undefined);
                        setEditCrsEntry(undefined);
                      }}
                    >
                      Cancel
                    </Button>
                  </td>
                </>
              )}
            </tr>
          ))
        )}
      </tbody>
      {!editCrsEntry && !selectedCrsEntry && (
        <tfoot>
          <tr>
            <td colSpan={5}>
              {!disabled && (
                <Button
                  onClick={() => {
                    let entry = {
                      hsn: "",
                      tsn: "",
                      description: "",
                    };
                    setEditCrsEntry(entry);
                    setSelectedCrsEntry(undefined);
                  }}
                >
                  Add new
                </Button>
              )}
            </td>
          </tr>
        </tfoot>
      )}
      {editCrsEntry && !selectedCrsEntry && (
        <tfoot>
          <tr>
            <td></td>
            <td>
              <Form.Control
                defaultValue={editCrsEntry.hsn}
                onChange={(e) => (editCrsEntry.hsn = e.target.value)}
              />
            </td>
            <td>
              <Form.Control
                defaultValue={editCrsEntry.tsn}
                onChange={(e) => (editCrsEntry.tsn = e.target.value)}
              />
            </td>
            <td>
              <Form.Control
                defaultValue={editCrsEntry.description}
                onChange={(e) => (editCrsEntry.description = e.target.value)}
              />
            </td>
            <td>
              <Button
                onClick={(evt) => {
                  crsEntryAdded(editCrsEntry);
                  setSelectedCrsEntry(undefined);
                  setEditCrsEntry(undefined);
                }}
              >
                Update
              </Button>
              <Button
                onClick={() => {
                  setSelectedCrsEntry(undefined);
                  setEditCrsEntry(undefined);
                }}
              >
                Cancel
              </Button>
            </td>
          </tr>
        </tfoot>
      )}
    </Table>
  );
}

export default CrsHsnTsn;
